import styled from 'styled-components';
import { Container } from 'styled/layouts/container';
import { motion } from 'motion/react';
import {
  mqMediumMin,
  mqLargeMin,
  mqLargeMax,
  mqXXLargeMin,
} from 'styled/tools/media-queries';

export const ProductAction = styled(Container)<{ justify?: string }>`
  --padding: calc(100% - 1440px);
  align-items: center;
  display: flex;
  justify-content: end;
  gap: var(--spacing-8);
  padding-inline: var(--spacing-16);
  width: calc(100% - var(--spacing-16) * 2);

  @media ${mqMediumMin} {
    padding-inline: var(--spacing-24);
    width: calc(100% - var(--spacing-24) * 2);
  }

  @media ${mqLargeMin} {
    padding-inline: var(--spacing-32);
    width: calc(100% - var(--spacing-32) * 2);
  }

  @media ${mqLargeMax} {
    justify-content: ${({ justify }) =>
      justify === 'end' ? 'flex-end' : 'space-between'};
  }

  @media ${mqXXLargeMin} {
    padding-inline: calc(var(--padding) / 2);
  }
`;

export const CardGroup = styled.div`
  display: flex;
  gap: var(--spacing-16);
`;

export const DotsPagination = styled.div`
  display: flex;
  margin-left: auto;
  gap: var(--spacing-8);
`;

export const Dot = styled(motion.span)<{ $color: 'seedgreen' | 'snowwhite' }>`
  border-radius: var(--radius-full);
  background: ${(props) =>
    props.$color === 'seedgreen' ? 'var(--fill-primary)' : 'var(--fill-brand)'};
  display: block;
  height: 8px;
`;

export const ReviewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--scrim-glass-dark-08, rgba(87, 94, 85, 0.08));
  border-radius: var(--radius-full);
  padding-inline: 12px var(--spacing-24);
  padding-block: 12px;
  min-width: 220px;

  @media ${mqLargeMin} {
    margin-inline: auto;
    min-width: 33%;
  }
`;

export const ReviewThumb = styled.figure`
  aspect-ratio: 1 / 1;
  align-items: center;
  border-radius: 100%;
  display: flex;
  overflow: hidden;
  max-width: 30px;

  & > img,
  & > picture,
  & > video {
    block-size: 100%;
    inline-size: 100%;
    object-fit: cover;
  }
`;

export const ReviewThumbsWrapper = styled.div`
  display: flex;
`;
